// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "svg[data-v-f9f04318]{width:14px;height:14px}", ""]);
// Exports
module.exports = exports;
